import React from 'react'
import { Dialog } from '@mui/material'
import DocumentView from './DocumentView'
import '../common/detail/detail.css'

interface DocumentModalProps {
  open: boolean
  onClose: () => void
  document: any
  isLoading?: boolean
}

const DocumentModal: React.FC<DocumentModalProps> = ({
  open,
  onClose,
  document,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      className="doc-viewer-modal"
      PaperProps={{ className: 'incyia-modal-paper' }}
    >
      <DocumentView document={document} onClose={onClose} />
    </Dialog>
  )
}

export default DocumentModal
